<template>
  <q-modal
      :value="opened"
      content-css="width: 400px;"
      @close="close()"
      @escape-key="close()"
      no-backdrop-dismiss
  >
    <div class="q-pa-lg">
      <div v-if="requisites">
        <div class="item">
          <router-link :to="editLink">Редактировать реквизиты проекта</router-link>
        </div>

        <div class="item">
          <div class="heading">Заказчик</div>
          <div class="body">{{ act.customer }}</div>
        </div>

        <div class="item">
          <div class="heading">Реквизиты</div>
          <div class="body" style="white-space: pre">Юридична адреса: {{ act.legal_address }}</div>
          <div class="body" style="white-space: pre">Фактична адреса: {{ act.actual_address }}</div>
          <div class="body" style="white-space: pre">ЄДРПОУ: {{ act.edrpou }}</div>
          <div class="body" style="white-space: pre">IПН: {{ act.inn }}</div>
          <div class="body" style="white-space: pre">IBAN: {{ act.iban }}</div>
        </div>

        <div class="item">
          <div class="heading">Инициалы заказчика</div>
          <div class="body">{{ act.initials }}</div>
        </div>

        <q-field>
          <q-datetime
              v-model="act.date"
              minimal
              clearable
              stack-label="Дата создания"
          />
        </q-field>
      </div>

      <div v-else>
        Перед формированием акта нужно заполнить
        <router-link :to="editLink">реквизиты проекта</router-link>
      </div>

      <div class="row justify-end q-mt-md">
        <q-btn v-if="requisites"
               @click="viewActPage()"
               color="primary"
               label="Просмотр"
        />
        <q-btn
            @click="close()"
            color="primary"
            flat
            class="q-ml-sm"
            label="Отмена"
        />
      </div>
    </div>
  </q-modal>
</template>

<script>
import { QBtn, QDatetime, QField, QInnerLoading, QInput, QModal, QSpinner } from 'quasar'
import { mapGetters } from 'vuex'

export default {
  name: 'ActModal',

  components: {
    QInput,
    QBtn,
    QField,
    QDatetime,
    QModal,
    QInnerLoading,
    QSpinner,
  },

  data () {
    return {
      act: {
        customer: '',
        requisites: '',
        initials: '',
        date: Date.now(),
      },
    }
  },

  props: {
    opened: true,
    bill: Object,
    actType: String,
    document: Object,
  },

  computed: {
    editLink () {
      return { name: 'user-payments-data', params: { id: this.bill.user_id } }
    },

    ...mapGetters({
      requisites: 'project/requisites',
    }),
  },

  methods: {
    viewActPage () {
      this.$router.push({
        name: typeof this.actType !== undefined && this.actType === 'START-PAY'
              ? 'start-pay-act'
              : 'act',
        params: {
          bill: this.bill,
          act: this.act,
          document: this.document,
        },
      })
    },

    close () {
      this.$emit('update:opened', false)
    },

  },

  mounted () {
    this.act = { ...this.requisites }

    let date = typeof this.document !== 'undefined' ? this.document.startDate : this.bill.service.valid_from
    let validFromDate = new Date(date)

    if (typeof this.actType !== 'undefined' &&
        (this.actType === 'START-PAY' || this.bill.service.service.groupId === 'other')) {
      this.act.date = this.bill.paid_at ? this.bill.paid_at : Date.now()
    }
    else {
      this.act.date = typeof this.document !== 'undefined'
                      ? this.document.endDate
                      : this.bill.service.valid_until || validFromDate.setDate(validFromDate.getDate() + 14)
    }
  },
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/BillsList/ActModal.vue